if (!customElements.get('bb-product-offers')) {
  customElements.define('bb-product-offers', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      document.addEventListener('bb:offer-source-ready', () => this.mount(), {signal:this.controller.signal});
      this.mount();
    }
    mount() {
      const source = document.querySelector('bb-product-offers-source template');
      if (!source) { this.replaceChildren(); return; }
      const fragment = source.content.cloneNode(true);
      const offers = fragment.querySelector('bb-cart-offers');
      if (!offers) return;
      offers.dataset.productId = this.dataset.productId;
      offers.dataset.collectionIds = this.dataset.collectionIds;
      this.replaceChildren(fragment);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('bb-product-offers-source')) {
  customElements.define('bb-product-offers-source', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => document.dispatchEvent(new CustomEvent('bb:offer-source-ready'))); }
    disconnectedCallback() { queueMicrotask(() => document.dispatchEvent(new CustomEvent('bb:offer-source-ready'))); }
  });
}
if (!customElements.get('bb-product-videos')) {
  customElements.define('bb-product-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      const options = {signal:this.controller.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-video-open]');
        if (button) {
          const template = this.querySelector('template[data-video-content="'+button.dataset.videoOpen+'"]');
          if (!template) return;
          this.opener = button;
          this.querySelector('[data-video-player]').replaceChildren(template.content.cloneNode(true));
          this.overflow = document.body.style.overflow;
          this.locked = true;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
          this.dialog.querySelector('video')?.play()?.catch(() => {});
        }
        if (event.target.closest('[data-video-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      },options);
      this.dialog.addEventListener('close',()=>this.release(),options);
    }
    release() {
      this.dialog.querySelectorAll('video').forEach(video=>video.pause());
      this.querySelector('[data-video-player]').replaceChildren();
      if (this.locked) document.body.style.overflow = this.overflow;
      this.locked = false;
      if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      if (this.dialog) this.release();
      this.controller?.abort();this.controller=null;
    }
  });
}
if (!customElements.get('bb-product-videos-source')) {
  customElements.define('bb-product-videos-source', class extends HTMLElement {
    connectedCallback() {
      this.mount();
      this.observer = new MutationObserver(()=>this.mount());
      const main = document.querySelector('main');
      if (main) this.observer.observe(main,{childList:true,subtree:true});
    }
    mount() {
      if (this.instance?.isConnected) return;
      const info = document.querySelector('main .product-info');
      const template = this.querySelector('template');
      if (!info || !template) return;
      const position = this.dataset.position || 'below_buy';
      let target = document.getElementById('ss-product-videos');
      let after = position.startsWith('below_');
      if (!target) {
        target = info.querySelector(position.includes('title') ? '.product-info__title' : position.includes('description') ? '.product-info__description' : '.product-info__buy-buttons');
        if (position === 'below_buy' && target?.nextElementSibling?.matches('.product-info__cashback')) target=target.nextElementSibling;
      }
      this.instance = template.content.firstElementChild.cloneNode(true);
      if (target) target.insertAdjacentElement(after ? 'afterend' : 'beforebegin',this.instance);
      else info.append(this.instance);
    }
    disconnectedCallback() { this.observer?.disconnect();this.instance?.remove(); }
  });
}
